import { omit } from 'lodash'

export const LABELING_STATUS = {
  /** labeler */
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  PENDING_REVIEW: 'PENDING_REVIEW',
  /** reviewer */
  REVIEW_IN_PROGRESS: 'REVIEW_IN_PROGRESS',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
}

export const LABELING_TOOL_TYPE = {
  USER: 'USER',
  MAGIC_WAND: 'MAGIC_WAND',
  AUTO_PIXEL: 'AUTO_PIXEL',
  LABELING_ASSISTANT: 'LABELING_ASSISTANT',
  STAMP: 'STAMP',
  SEMI_AUTO_LABELING: 'SEMI_AUTO_LABELING',
}

export const AUTO_LABELING_TOOL_TYPE = omit(LABELING_TOOL_TYPE, ['USER'])

export const LABELING_STATUS_TEXT = {
  [LABELING_STATUS.NOT_STARTED]: 'pipeline_labeling_status_notStarted',
  [LABELING_STATUS.IN_PROGRESS]: 'pipeline_labeling_status_inProgress',
  [LABELING_STATUS.FINISHED]: 'labeling_itemStatus_finished',
  [LABELING_STATUS.PENDING_REVIEW]: 'pipeline_labeling_status_pendingReview',
  [LABELING_STATUS.REVIEW_IN_PROGRESS]: 'pipeline_labeling_status_reviewInProgress',
  [LABELING_STATUS.REJECTED]: 'pipeline_labeling_status_rejected',
  [LABELING_STATUS.COMPLETED]: 'labeling_itemStatus_completed',
}

export const LABEL_ONGOING = [LABELING_STATUS.NOT_STARTED, LABELING_STATUS.REJECTED]
export const LABEL_FINISHED = [LABELING_STATUS.FINISHED, LABELING_STATUS.COMPLETED]
export const REVIEW_ONGOING = [LABELING_STATUS.REVIEW_IN_PROGRESS]
export const REVIEW_FINISHED = [LABELING_STATUS.REJECTED, LABELING_STATUS.COMPLETED]

/** classification-items 의 `tag` 파라미터. 미분류 = 태그가 0개인 아이템 */
export const LABELING_TAG_FILTER = {
  UNTAGGED: 'UNTAGGED',
} as const
